<mat-autocomplete (optionSelected)="choiceSelected($event)">
  <mat-option *ngFor="let item of filterObservable | async" [value]="item[valueProperty]">
    <span>
      <span>{{ item[keyProperty] }}</span>
    </span>
  </mat-option>
</mat-autocomplete>